import i18n from 'i18next';

// Only render legal text if it there is a defined text (not matches the key)
export function getLegalText(countryCode = ''): string | null {
  const legalTextKey = `SHOP_${countryCode?.toUpperCase()} | Legal text`;
  const legalText = i18n.t(legalTextKey);
  return legalText !== legalTextKey ? legalText : null;
}
